import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

export interface Select2ApplyBarProps {
  onApply: () => void;
}

export function Select2ApplyBar({ onApply }: Select2ApplyBarProps) {
  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      sx={{
        pt: 3,
      }}
    >
      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={onApply}
      >
        Apply
      </Button>
    </Stack>
  );
}
